import { defaultChainId } from '../config/chains';
import { useLoadContract } from './useLoadContract';
export const useGetProtocolContract = (contractName, chain = defaultChainId, customSigner) => useLoadContract(contractName, 'protocol', chain, customSigner);
export const useGetTokenContract = (contractName, chain = defaultChainId, customSigner) => useLoadContract(contractName, 'tokens', chain, customSigner);
